import type { FooterLinkGroup, SocialLink } from './FooterTypes';

import facebookSVG from './icons/facebook.svg';
import instagramSVG from './icons/instagram.svg';
import linkedinSVG from './icons/linkedin.svg';
import twitterSVG from './icons/twitter.svg';

// Footer data

export const linkGroups: FooterLinkGroup[] = [
  {
    key: 'products',
    title: 'PRODUCTS AND SERVICES',
    links: [
      { label: 'Products', href: '/products' },
      { label: 'Services', href: '/services' },
    ],
  },
  {
    key: 'company',
    title: 'COMPANY',
    links: [
      { label: 'About Us', href: '/about-us' },
      { label: 'Blogs', href: '/blogs' },
    ],
  },
  {
    key: 'business',
    title: 'WHO WE DO BUSINESS WITH',
    links: [
      { label: 'Government', href: '/government' },
      { label: 'Business', href: '/business' },
      { label: 'Nonprofit', href: '/nonprofit' },
    ],
  },
  {
    key: 'contact',
    title: 'CONTACT US',
    links: [
      { label: 'Support', href: '/support' },
      { label: 'Careers', href: '/careers' },
      { label: 'Sales', href: '/sales' },
    ],
  },
  {
    key: 'information',
    title: 'INFORMATION',
    links: [
      {
        label: 'Privacy Policy',
        href: 'https://dashboard.wildcardcorp.com/index.php?/knowledgebase/article/16/wildcard-corp-privacy-policy---disclaimer/',
        external: true,
      },
      {
        label: 'Terms and Conditions',
        href: 'https://dashboard.wildcardcorp.com/index.php?/knowledgebase/article/11/terms-of-service/',
        external: true,
      },
      {
        label: 'Section 508 Compliance',
        href: '/section-508-compliance',
      },
      {
        label: 'HUBZone',
        href: '/hubzone',
      },
      {
        label: 'GSA IT Schedule 70',
        href: '/gsa-it-schedule-70',
      },
    ],
  },
];

export const socialLinks: SocialLink[] = [
  {
    key: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/wildcardcorp',
    icon: facebookSVG,
    iconClassName: 'footer-socialIcon--facebook',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/wildcardcorp/',
    icon: instagramSVG,
    iconClassName: 'footer-socialIcon--instagram',
  },
  {
    key: 'linkedin',
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/wildcard-corp/',
    icon: linkedinSVG,
    iconClassName: 'footer-socialIcon--linkedin',
  },
  {
    key: 'twitter',
    label: 'Twitter',
    href: 'https://x.com/WildcardCorp',
    icon: twitterSVG,
    iconClassName: 'footer-socialIcon--twitter',
  },
];
